
import { associationPaths } from './paths/AssociationPaths';
import { documentPaths } from './paths/DocumentPaths';
import { pricingPaths } from './paths/PricingPaths';
import { feesApportionPartyPaths } from './paths/FeesApportionPartyPaths';
import { otherPaths } from './paths/OtherPaths';
import { customerPaths } from './paths/CustomerPaths';
import { documentFormPaths } from './paths/DocumentFormPaths';
import { documentBundlePaths } from './paths/DocumentBundlePath';
import { formBuilderPaths } from './paths/FormBuilderPaths';
import { customerOrderPaths } from './paths/CustomerOrderPaths';
import { propertyPaths } from './paths/PropertyPaths';
import { cmsPaths } from './paths/CMSPaths';

export const apiPaths = {
  ...associationPaths,
  ...documentPaths,
  ...pricingPaths,
  ...feesApportionPartyPaths,
  ...otherPaths,
  ...customerPaths,
  ...documentFormPaths,
  ...documentBundlePaths,
  ...formBuilderPaths,
  ...customerOrderPaths,
  ...propertyPaths,
  ...cmsPaths
};
